import { Heading } from '@efdigital/ll-addon-ui';
import MessagesList from '@efdigital/ll-admin-v2/components/programs/messages/messages-list.gts';
import { queryCohortMessages } from '@efdigital/ll-admin-v2/data/builders/xceed/messages';
import type { ProgramsProgramCohortMessagesCategoryModel } from '@efdigital/ll-admin-v2/routes/programs/program/cohort/messages/category';
import { array } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';
import { Request } from '@warp-drive/ember';

interface Signature {
  Args: {
    model: ProgramsProgramCohortMessagesCategoryModel;
  };
}

export default class ProgramsProgramCohortMessagesCategoryIndexTemplate extends Component<Signature> {
  get category(): 'announcement' | 'discussion' {
    return this.args.model.category;
  }

  get categoryTitle(): string {
    return this.category === 'announcement' ? 'Announcements' : 'Discussions';
  }

  <template>
    <div class="container-fluid py-4">
      <ul class="nav nav-tabs mb-4">
        <li class="nav-item">
          <LinkTo
            @route="programs.program.cohort.messages.category.index"
            @models={{array @model.program_id @model.cohort_id "announcement"}}
            class="nav-link"
          >
            <iconify-icon inline icon="ph:megaphone-duotone" />
            Announcements
          </LinkTo>
        </li>
        <li class="nav-item">
          <LinkTo
            @route="programs.program.cohort.messages.category.index"
            @models={{array @model.program_id @model.cohort_id "discussion"}}
            class="nav-link"
          >
            <iconify-icon inline icon="ph:chat-circle-text-duotone" />
            Discussions
          </LinkTo>
        </li>
      </ul>

      <Heading @text={{this.categoryTitle}}>
        <LinkTo
          @route="programs.program.cohort.messages.category.new"
          @models={{array @model.program_id @model.cohort_id @model.category}}
          class="btn btn-primary"
        >
          <iconify-icon inline icon="ph:plus-bold" />
          New
          {{this.categoryTitle}}
        </LinkTo>
      </Heading>

      <Request @query={{queryCohortMessages @model.cohort_id @model.category}}>
        <:content as |content|>
          <MessagesList
            @messages={{content.data}}
            @category={{@model.category}}
            @programId={{@model.program_id}}
            @cohortId={{@model.cohort_id}}
          />
        </:content>
        <:error>
          <div class="alert alert-danger">
            <iconify-icon inline icon="ph:warning" />
            Failed to load messages.
          </div>
        </:error>
      </Request>
    </div>
  </template>
}
